import Check from "@Images/NewUI/disbursed.gif";
import loanFailed from "@Images/statusfailed.png";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HEADING_LOANSTATUS } from "../Common/constant";
import arrowleft from "@Images/NewUI/Vector.png";
import moment from "moment";
import Modal from "react-modal";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "../../../hooks/withRouter";
import { getNoc, loanStatusApi , getLoanData} from "../.../../../../Redux/ApplyLoan/action";
import alert from "../../../Images/NewUI/alert.png";
import ToastMsg from "../../../helper/ToastMsg";
import { Loader } from "../Common/Loader";

const LoanStatusEMI = (props) => {
  const navigate = useNavigate();
  // console.log(props , "sjhgkjfhgdskjsdhfkgjhdk");
  let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  // console.log(props, "emiid");
  const { event = "loan", canApply = true, userType = "old" } = props;
  const [loanStatusData, setLoanStatusData] = useState([]);
  const [state, setState] = useState({
    loanDetails: props.loanData,
  });
  const [getNocDisable, setGetNocDisable] = useState(true);
  const [loader, setLoader] = useState(true);
  const [showWithdrawPopup, setShowWithdrawPopup] = useState(false);
  const [showExpiredPopup, setShowExpiredPopup] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
   
    
    window.scrollTo(0, 0);
    handleLoanStatus();
    // handleLoanStatueData()
  }, []);
  const handlePupup = () =>{
    
    setShowWithdrawPopup(true)
   
  }
  const handleLoanStatus = () => {
    let data = {
      loan_id: props?.location?.state?.loan_id,
    };
    props
      .loanStatusApi(data, token)
      .then((res) => {
        setLoader(false);
        setLoanStatusData(res?.data?.data);
        // console.table("response loan Status", res?.data?.data);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const downloadNoc = (e) => {
    e.preventDefault();
    let data = {
      loan_id: props?.location?.state?.loan_id,
    };
    props
      .getNoc(data, token)
      .then((res) => {
        setLoader(false);
        if (res?.status === 200) {
          let succesMsg = res?.data?.message;
          if (getNocDisable) {
            setGetNocDisable(false);
            ToastMsg(succesMsg, "success");
            setTimeout(() => {
              setGetNocDisable(true);
            }, 5000);
          }
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const handleCancelbtn = () =>{
   
    setShowWithdrawPopup(false)
  }
  const handleWithdrawLoan = () => {

 

    if (loanStatusData[0]?.loan_cancellation === true) {
      window.location.href = "/withdraw_loan";
      setShowWithdrawPopup(false);
    } else {
      setShowExpiredPopup(true);
    }
  };
  const handleLoanStatueData = () => {
    let data = {};
    setLoader(true);
    props
      .getLoanData(data, token)
      .then((res) => {
        setLoader(false);
        if (res.status === 200) {
          setState({
            dueAmount: res?.data?.data?.due_amount,
            loanDetails: res?.data?.data,
          });
          
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;

        // ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const handleRepayRedirection = () => {

  

    const loanDetailsString = JSON.stringify(state.loanDetails);
    
    setTimeout(() => {
      navigate(`/loan_repay?loanDetails=${loanDetailsString}`);
    }, 1000);
  };

  return (
    <div id="backgroundhere" className="main_div">
       {isLargeScreen &&
            <div className="flexpt30 shadowlinels sticky-header">
                  <img
                    style={{ cursor: "pointer", marginLeft: 35 ,marginTop: "9px"}}
                    className="customimgfix"
                    src={arrowleft}
                    onClick={() => {
                      // window.location.href="/dashboard_s";
                      navigate(-1);
                    }}
                  />

                  <h1
                    className="boldheading"
                    style={{
                      paddingLeft: "30px",
                      color: "#152745",
                      fontWeight: "800",
                      fontSize: "25px",
                    }}
                  >
                    {HEADING_LOANSTATUS}
                  </h1>
                </div>}
      {loader ? <Loader /> : null}
      {loanStatusData.map((loan, index) => {
        return (
          <div key={index}>
            {/* {item?.loan_status === "DISBURSED" ? ( */}
            {!isLargeScreen &&
            <div className="customheading-status shadowlinels sticky-header">
                  <img
                    style={{ cursor: "pointer", marginLeft: 35 }}
                    className="customimgfix mt-2"
                    src={arrowleft}
                    onClick={() => {
                      // window.location.href="/dashboard_s";
                      navigate(-1);
                    }}
                  />

                  <h1
                    className="boldheading"
                    style={{
                      paddingLeft: "30px",
                      color: "#152745",
                      fontWeight: "800",
                      fontSize: "25px",
                    }}
                  >
                    {HEADING_LOANSTATUS}
                  </h1>
                </div>}
            <div className="container mt-20">
              <div className="pb-4">
                {/* <Heading
                  headingText={HEADING_LOANSTATUS}
                  backprops={"/loanhistory"}
                  history={props.history}
                /> */}
                <Modal isOpen={showWithdrawPopup} className="withdraw-popup">
                  <h3>Withdraw Loan?</h3>
                  <p>Are you sure you want to withdraw your loan request?</p>
                  <button className="confirm-btn" onClick={handleWithdrawLoan}>
                    Confirm
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={handleCancelbtn}
                  >
                    Cancel
                  </button>
                </Modal>
                <Modal isOpen={showExpiredPopup} className="expired-popup">
                  <img
                    width={67}
                    src={alert}
                    alt="Period_Expired"
                    className="expired-alert-img"
                  />
                  <h3>Period Expired!</h3>
                  <p>
                    You&apos;ve gone past the allowed time to withdraw the loan
                    request&#x2C; so now you can&apos;t withdraw it anymore.
                  </p>
                  <button
                    onClick={() => {
                      setShowExpiredPopup(false);
                      setShowWithdrawPopup(false);
                    }}
                  >
                    Okay
                  </button>
                </Modal>
                <div className="wrapper-content">
                  <div className="   w-100 mx-auto  ">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="pt-0 pb-0 font-size-16 shadow-new">
                        <div className="check_div text-center pb-fix">
                          {loan?.loan_status === "PASSED" ||
                          loan?.loan_status === "PAID" ||
                          loan?.loan_status === "SETTLED" ? (
                            <img
                              src={Check}
                              alt="success"
                              style={{ height: 72, width: 72 }}
                            />
                          ) : loan?.loan_status === "FAILED" ? (
                            <img src={loanFailed} alt="Failed" />
                          ) : (
                            <p className="progress_icon">
                              {/* <span>&#33;</span> */}
                              <img
                                src={Check}
                                alt="success"
                                style={{ height: 86, width: 86 }}
                              />
                            </p>
                          )}
                          <span style={{fontSize: "13px", fontWeight:"400"}} className="blur" >Status</span>
                          <span>
                            {loan.loan_status === null ? (
                              <p className="font-size-20">In Progress</p>
                            ) : (
                              <p className="font-size-20">{loan?.loan_status === "DISBURSED" ? "Disbursed Successfully" : loan?.loan_status}</p>

                            )}
                          </span>
                        </div>
                       <div className="lsemii">
                         <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Applied on</span>
                          <span>
                            <p>
                              {" "}
                              {loan.tenure_date
                                ? moment(loan.tenure_date).format("DD-MM-YYYY")
                                : ""}
                            </p>
                          </span>
                        </div>

                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Disbursed on</span>
                          <span>
                            {loan?.loan_status !== "FAILED" && loan?.disbursal_date ? (
                              <p>
                                 {moment(loan?.disbursal_date).format(
                                  "DD-MM-YYYY"
                                )} 
                              </p>
                            ) : (
                              <p>--</p>
                            )}
                          </span>
                        </div>
                        <div className="wrapper_m flex space-between align-centern ">
                          <span className="blur" >Repayment on</span>
                          <span>
                            {loan?.loan_status !== "FAILED" ? (
                              <p>
                                {moment(loan?.repayment_date).format(
                                  "DD-MM-YYYY"
                                )}
                              </p>
                            ) : (
                              <p>--</p>
                            )}
                          </span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(loan?.loan_status === "DISBURSED" ||
                  loan?.loan_status === "BALANCE_AMOUNT") && !loan?.emi_details.length > 0 ? (
                    <>
                      <div className="loan-sub-h rdfix">Repayment Details</div>
                      <div className="   w-100 mx-auto  shadow-new ">
                        <div className="d-flex flex-column justify-content-between">
                          <div className="pt-0 pb-0 font-size-16">
                            <div className="wrapper_m mtop-10 lspadding flex space-between align-center">
                              <span className="blur" >Current Due Amount (On Due Date)</span>
                              <span>
                                <p>₹{loan?.due_amount}</p>
                              </span>
                            </div>
                            {loan?.collection_amount > 0 ? (
                              <div>
                                <div className="wrapper_m lspadding flex space-between align-center">
                                  <span  className="blur" >Collection amount</span>
                                  <span>
                                    <p>₹{loan?.collection_amount}</p>
                                  </span>
                                </div>
                                <div className="wrapper_m lspadding flex space-between align-center">
                                  <span  className="blur" >Collection date</span>
                                  <span>
                                    <p>
                                      {loan.collection_date
                                        ? moment(loan.collection_date).format(
                                            "DD-MM-YYYY"
                                          )
                                        : "NA"}
                                    </p>
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="loan-sub-h rdfix">Loan statement</div>

                  <div className="   w-100 mx-auto lspaddingTop radius10 shadow-new ">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="pt-0 pb-0 font-size-16 lspadding ">
                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Sanctioned amount</span>
                          <span>
                            <p>₹{loan?.amount}</p>
                          </span>
                        </div>
 {loan?.bharti_axa_insurance[0]?.total_premium &&

                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Insurance Amount</span>
                          <span>
                            <p>₹{loan?.bharti_axa_insurance[0]?.total_premium}</p>
                          </span>
                        </div>}


                        <div className="mb-7 flex space-between align-center">
                          <span className="blur" >Original Due Date</span>
                          <span>
                            <p>
                              {loan?.repayment_date
                                ? moment(loan.repayment_date).format(
                                    "DD-MM-YYYY"
                                  )
                                : "NA"}
                            </p>
                          </span>
                        </div>
                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Original Due Amount</span>
                          <span>
                            <p>₹{loan?.repayment_amount}</p>
                          </span>
                        </div>
                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Interest(per day)</span>
                          <span>
                            <p>{loan.fee_at_that_time.current_roi}%</p>
                          </span>
                        </div>
                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Tenure days</span>
                          <span>
                            <p>{loan?.tenure_days}</p>
                          </span>
                        </div>
                        <div className="wrapper_m flex space-between align-center">
                          <span className="blur" >Processing fee</span>
                          <span>
                            <p>
                              ₹{loan?.fee_at_that_time?.current_processing_fee}
                            </p>
                          </span>
                        </div>

                        {loan?.loan_status !== "DISBURSED" ? (
                          <div>
                            <div className="wrapper_m flex space-between align-center">
                              <span className="blur" >Collection amount</span>
                              <span>
                                <p>₹{loan?.collection_amount}</p>
                              </span>
                            </div>
                            <div className="wrapper_m flex space-between align-center">
                              <span className="blur" >Collection date</span>
                              <span>
                                <p>
                                  {loan.collection_date
                                    ? moment(loan.collection_date).format(
                                        "DD-MM-YYYY"
                                      )
                                    : "NA"}
                                </p>
                              </span>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  {loan?.emi_details.length > 0 && loan?.loan_status !== "PAID" ? (
                    <>
                      <div className="loan-sub-h ">EMI details</div>

                      <div className=" shadow-new  w-100 mx-auto  ">
                        <div className="d-flex flex-column  justify-content-between">
                          <div className="pt-0 pb-0">
                            <table className="emi-sc mt-20">
                                <tr className="font-size-18">
                                  <td>EMI</td>
                                  <td>Due</td>
                                  <td>Date</td>
                                  <td>Status</td>
                                </tr>
                              {loan?.emi_details?.map((item, index) => {
                                return (
                                    <tr className="font-size-16" key={index}>
                                      {" "}
                                      <td className="blur" >₹{item?.repayment_amount}</td>{" "}
                                      <td className="blur" >₹{item?.due_amount}</td>{" "}
                                      <td className="blur" >{moment(item?.repayment_date).format("DD-MM-YYYY")}</td>{" "}
                                      <td
                                        className={item}
                                        style={{
                                          color:
                                            item?.status === "PAID"
                                              ? "#1dbf73"
                                              : item?.status === "UNPAID"
                                              ? "red"
                                              : "",
                                        }}
                                      >
                                        {" "}
                                        {item?.status} <span style={{color: "#152745"}}>{">"}</span>
                                      </td>{" "}
                                    </tr>
                                );
                              })}
                            </table>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {loan.loan_status === "PAID" ||
                  loan.loan_status === "SETTLED" ? (
                    <div className="button-wrapper sticky-button-container  text-center">
                      <button
                        onClick={downloadNoc}
                        className="NbfcBtntext2"
                        disabled={!getNocDisable}
                      >
                        Get NOC
                      </button>
                    </div>
                  ) : loan.loan_status === "DISBURSED" ||
                    loan.loan_status === "BALANCE_AMOUNT" ? (
                    <>
                      <div className="button-wrapper mtop-10 sticky-button-container  marginfix-lse  text-center">
                          <div
                            style={{ marginTop: 15}}
                            className="GetNowBtnrepayfix"
                            onClick={handleRepayRedirection}
                          >
                            <div>Repay Now</div>
                          </div>
                          <div
                        className="withdraw-text"
                        onClick={handlePupup}
                      >
                        Withdraw Loan 
                      </div>
                      </div>
                     
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, { loanStatusApi,getLoanData, getNoc })(
  LoanStatusEMI
));